// Should be initialized after reverb.attachinary.js

function init() {
  $('[data-attachinary]').each(function () {
    var attachinaryInput = $(this);
    var attachinaryTemplate = attachinaryInput.data('attachinary-template');
    var options = attachinaryTemplate ? { template: $(attachinaryTemplate).html() } : {};
    var attachinaryData = attachinaryInput.data('attachinary');
    var files = attachinaryData.files;

    var previewUrl = $(this).data('preview-url');
    if (previewUrl && files && files.length === 1) {
      files[0].preview_url = previewUrl;
    }

    attachinaryData.files = files;
    attachinaryInput.data('attachinary', attachinaryData);
    attachinaryInput.attachinary(options);
  });
}

$(init);

module.exports = init;



// WEBPACK FOOTER //
// ./javascripts/components/attachinary_fields.js